exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acl-configuration{padding:24px}.acl-configuration__upload{margin-top:40px}.acl-configuration__content p{margin-top:10px}.acl-configuration__title{line-height:24px;text-transform:uppercase;font-size:16px;color:black}.acl-configuration__label{margin:10px 0px !important;color:#767676;font-size:12px;font-weight:700;text-transform:capitalize}.acl-configuration__picker .el-date-editor{width:240px}.acl-configuration__endcampaign{margin-top:40px;padding:24px;background-color:#fff0f1;max-width:fit-content}.acl-configuration__endbutton{margin:10px 0px;color:white}\n", ""]);

// exports
